import ReactGA from 'react-ga';

const { REACT_APP_GA } = process.env;

ReactGA.initialize(REACT_APP_GA);

export default REACT_APP_GA ? ReactGA : null;
